import Api from './Api'
import axios from 'axios'

export default {
  search (query, page) {
    return Api().post('/kunde/search.json',
      {q: query},
      {params: {page: page || 1}}
    )
  },

  index (page) {
    return Api().get('/kunde.json', {
      params: {
        page: page || 1
      }
    })
  },

  view (id) {
    return Api().get('/kunde/' + id + '.json')
  },

  save (id, data) {
    if (!id) {
      return Api().post('/kunde.json', data)
    }

    return Api().put('/kunde/' + id + '.json', data)
  },

  findByEmail (email) {
    return Api().get('/kunde/find_by_email.json', {
      params: {
        email: email
      }
    })
  },

  getKundeBilag (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/bilag.json', {
      params: queryParams
    })
  },

  getKundeBilagPdf (bilagsId) {
    return Api().get('/bilag/' + bilagsId + '/pdf.json')
  },

  getKundeBilagStrekkode (bilagsId) {
    return Api().get('/bilag/' + bilagsId + '/barcode.json')
  },
  getKundeFullmakter (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kundefullmakt.json', {
      params: queryParams
    })
  },

  addKundeFullmakt (kundeId, fullmaktId, data) {
    if (!fullmaktId) {
      return Api().post('/kunde/' + kundeId + '/kundefullmakt.json', data)
    }

    return Api().put('/kunde/' + kundeId + '/kundefullmakt/' + fullmaktId + '.json', data)
  },

  getKundeNotater (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kundenotat.json', {
      params: queryParams
    })
  },

  addKundeNotat (kundeId, notat) {
    return Api().post('/kunde/' + kundeId + '/kundenotat.json', {
      Notat: notat
    })
  },

  delKundeNotat (kundeId, notatId) {
    return Api().delete('/kunde/' + kundeId + '/kundenotat/' + notatId + '.json')
  },

  getObjektWhereKundeIsBuyer (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/buyer.json', {
      params: queryParams
    })
  },

  // When ready to deliver obj, see: ObjektService
  getDeliverableObjects (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/get-deliverable-objects.json', {
      params: queryParams
    })
  },

  setDeliverableObjectsDelivered: function (kundeId, data) {
    if (!kundeId) {
      return Api().post('/kunde/set-deliverable-objects-delivered-vinpakkeliste.json', data)
    }
    return Api().post('/kunde/' + kundeId + '/set-deliverable-objects-delivered.json', data)
  },

  getObjektWhereKundeIsSeller (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/seller.json', {
      params: queryParams
    })
  },

  getObjektWhereKundeNotInvoicedIsBuyer (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/invoice/buyer.json', {
      params: queryParams
    })
  },
  getKundeHistory (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/history.json', {
      params: queryParams
    })
  },

  getKundeKontraktHistory (kundeId, kontraktId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/history.json', {
      params: queryParams
    })
  },

  getKundeKontraktObjektHistory (kundeId, kontraktId, objektId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt/' + objektId + '/history.json', {
      params: queryParams
    })
  },

  getKundeKontraktList (kundeId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kontrakt.json', {
      params: queryParams
    })
  },

  getKundeKontrakt (kundeId, kontraktId) {
    return Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '.json')
  },

  saveKundeKontrakt (kundeId, kontraktId, data) {
    if (!kontraktId) {
      return Api().post('/kunde/' + kundeId + '/kontrakt.json', data)
    }

    return Api().put('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '.json', data)
  },

  deleteKundeKontrakt (kundeId, kontraktId) {
    return Api().delete('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '.json')
  },

  makeKundeKontraktPdf (kundeId, kontraktId, postData) {
    return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/make-pdf-kontrakt.json', postData)
  },

  makeKundeKvitteringPdf (kundeId, kontraktId, postData) {
    return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/make-pdf-kvittering.json', postData)
  },

  makeKundeArtsafePdf (kundeId, kontraktId, postData) {
    return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/make-pdf-artsafe.json', postData)
  },

  getKundeKontraktPdf (kundeId, kontraktId, postData) {
    return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/get-historical-pdf.json', postData)
  },

  getKundeKontraktObjektList (kundeId, kontraktId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt.json', {
      params: queryParams
    })
  },
  getKundeKontraktObjekInvoicetList (kundeId, kontraktId, queryParams) {
    return Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/invoice/objekt.json', {
      params: queryParams
    })
  },
  getKundeKontraktObjekt (kundeId, kontraktId, objektId) {
    return Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt/' + objektId + '.json')
  },
  saveInvoices (kundeId, data) {
    return Api().post('/kunde/' + kundeId + '/bilag/buyer.json', data)
  },
  saveKundeKontraktObjekt (kundeId, kontraktId, objektId, data) {
    if (!objektId) {
      return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt.json', data)
    }

    return Api().put('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt/' + objektId + '.json', data)
  },

  deleteKundeKontraktObjekt (kundeId, kontraktId, objektId) {
    return Api().delete('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt/' + objektId + '.json')
  },

  loadKundeWithKontraktAndObjekt (kundeId, kontraktId, objektId) {
    return new Promise((resolve, reject) => {
      axios
        .all([
          Api().get('/kunde/' + kundeId + '.json'),
          Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '.json'),
          Api().get('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/objekt/' + objektId + '.json')
        ])
        .then(
          axios.spread(function (kunde, kontrakt, objekt) {
            resolve({
              kunde: kunde.data,
              kontrakt: kontrakt.data,
              objekt: objekt.data
            })
          })
        )
        .catch(error => {
          reject(error)
        })
    })
  },

  moveObjektToNewKontrakt (kundeId, kontraktId, formData, objektArray) {
    return Api().post('/kunde/' + kundeId + '/kontrakt/' + kontraktId + '/transfer-objekt.json', {
      objekt: objektArray,
      kontraktdata: formData
    })
  },

  loadFormDropdowns () {
    return new Promise((resolve, reject) => {
      Api().get('kunde/dropdowns.json')
        .then((response) => {
          resolve(response.data)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },

  kataloglist (queryParams) {
    return Api().get('/kunde/kataloglist.json', {
      params: queryParams
    })
  },

  getKnowYourCustomerList (queryParams) {
    return Api().get('/kunde/know-your-customer-list.json', {
      params: queryParams
    })
  },

  sendEmail (kundenr, post) {
    return Api().post('/kunde/' + kundenr + '/send-email.json', post)
  }
}



// WEBPACK FOOTER //
// ./src/services/KundeService.js